<template>
    <div>
        <ValueVoucherStatusView v-if="voucher.multiVoucher || voucher.valueVoucher || voucher.accessCode"/>

        <HotelVoucherStatusView v-else />

        <div class="card-navigation">
            <button class="btn btn-secondary" @click="$store.dispatch('reset')">
                {{$t('voucherStatus.reset')}}
            </button>
        </div>
    </div>
</template>

<script>
    import ValueVoucherStatusView from '@/components/ValueVoucherStatusView';
    import HotelVoucherStatusView from '@/components/HotelVoucherStatusView';

    export default {
        name: 'VoucherStatus',
        components: {
            ValueVoucherStatusView,
            HotelVoucherStatusView
        },
        computed: {
            voucher() {
                return this.$store.state.voucher;
            }
        }
    }
</script>
